import { createTestIds } from '../../utils';

export const getLinkTestIds = createTestIds('link', [
  'preview-popover',
  'preview',
  'new-tab'
] as const);
